<template>
  <v-card v-if="selectedProperty" style="background-color: #fafafa;">
    <v-toolbar
      color="primary lighten-1"
      dark
      elevation="0"
    >
      <v-card-title>
        {{ selectedProperty.geoname }}
        <v-card-subtitle>{{isSecurity ? 'Property' : 'Location'}} Detail</v-card-subtitle>
      </v-card-title>
      <v-spacer></v-spacer>
      <v-btn color="white" icon dark @click="currentProperty = null">
        <v-icon dark>mdi-close-box</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <isochrone-map></isochrone-map>
      <v-row>
        <v-col
          v-for="group in groups"
          :key="group"
          :cols="12 / groups.length"
        >
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 4 : 0" style="background-color: #fafafa;">
              <v-card-title v-text="`${group} Summary`" />
              <v-card-text>
                <climate-summary :rscores="isochroneRScores[focusedRadius]" v-if="((properties) || (summaryRscores)) && group === 'Climate'"></climate-summary>
                <social-summary :socialData="isochroneData[focusedRadius]" v-else-if="((properties) || (results)) && group === 'Social'"></social-summary>
                <div v-else>-</div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { makePowerpoint } from '@/utils/powerpoint_generator'
import IsochroneMap from '@/components/IsochroneMap.vue'
import ClimateSummary from '@/components/ClimateSummary.vue'
import SocialSummary from '@/components/SocialSummary.vue'

export default {
  name: "PropertyDetails",
  data() {
    return {
      map: null,
      groups: ['Climate','Social'],
      initialPowerpointDataToGenerate:  ['propertyName', 'driveTime', 'climateMapUrl', 'socialMapUrl', 'gaugeUrls', 'socialImpactUrl', 'subscoreUrl']
    }
  },
  components: {
    IsochroneMap,
    ClimateSummary,
    SocialSummary
  },
  computed: {
    isSecurity: function() {
      return Boolean(this.selectedProperty && this.selectedProperty.cusip)
    },
    currentProperty: {
      get() { return this.selectedProperty },
      set() { this.$store.dispatch('clearSelectedProperty') }
    },
    mapNeedsToBeInitialized() {
      return this.map === null && this.properties
      // return true
    },
    subscoreTypes() {
      return ['hurricane', 'flood', 'wildfire']
    },
    ...mapGetters(['isochroneScores']),
    ...mapState({
      cusip: (state) => state.currentCusip,
      results: (state) => state.currentCusipData,
      summary: (state) => state.summaryData,
      properties: (state) => state.propertyData,
      mapPoints: (state) => state.mapPoints,
      loading: (state) => state.loading,
      driveTimeOptions: (state) => state.driveTimeOptions,
      selectedProperty: (state) => state.selectedProperty,
      showDriveTimeTable: (state) => state.showDriveTimeTable,
      isochrones: (state) => state.isochrones,
      isochroneRScores: (state) => state.isochroneRScores,
      isochroneData: (state) => state.isochroneData,
      focusedRadius: (state) => state.focusedRadius,
      mapMode: (state) => state.mapMode,
      powerpointData: (state) => state.powerpointData,
      startPowerpointGeneration: (state) => state.startPowerpointGeneration,
      powerpointDataToGenerate: (state) => state.powerpointDataToGenerate
    })
  },
  methods: {
    resetPowerpointState: function() {
        this.$store.dispatch('updateState', ['powerpointDataToGenerate', this.initialPowerpointDataToGenerate])
        this.$store.dispatch('updateState', ['startPowerpointGeneration', false])
        this.$store.dispatch('updateState', ['powerpointData', {}])
    }
  },
  watch: {
    startPowerpointGeneration(newValue) {
        if(newValue === true) {
            let powerpointData = this.powerpointData
            //update propertyName and driveTime in powerpointData
            powerpointData['propertyName'] = this.selectedProperty.geoname;
            powerpointData['driveTime'] = this.focusedRadius

            //remove 'propertyName' and 'driveTime' from powerpointDataToGenerate
            let powerpointDataToGenerate = this.powerpointDataToGenerate.filter((name) => {
                return (name !== 'propertyName') && (name !== 'driveTime')
            })
            this.$store.dispatch('updateState', ['powerpointDataToGenerate', powerpointDataToGenerate])
        }
    },
    powerpointDataToGenerate(newVal) {
        if(newVal.length === 0) {
            makePowerpoint(this.powerpointData)
            this.resetPowerpointState()
        }
    }
  }
}
</script>
